import { SxStyle } from '../../types/style';

const contentStack: SxStyle = {
    justifyContent: 'center',
    alignItems: 'center',
    height: { xs: 'fitContent', md: '100vh' }
};

const contentStackBoxTypography: SxStyle = {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: '700',
    fontSize: '32px'
}

export const loginStyle = {
    contentStack,
    contentStackBoxTypography,
};